// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Placemarks Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Placemarks Worker')

  // $FlowFixMe
  const PlacemarkWorker = require('worker-loader?name=[hash].placemarks.wrkr.js!./worker.js')
  worker = new PlacemarkWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
